export default class Molenwijk {
    constructor() {
        const popup = document.getElementById('molenwijk-popup');
        if (!popup || typeof popup.showModal !== 'function') return;

        try {
            if (sessionStorage.getItem('molenwijk-popup-dismissed') === '1') return;
        } catch (error) {
            // Closing the popup still works if browser storage is unavailable.
        }

        popup.querySelector('.molenwijk-popup-close').addEventListener('click', () => popup.close());
        popup.addEventListener('click', event => {
            if (event.target === popup) popup.close();
        });
        popup.addEventListener('close', () => {
            document.body.classList.remove('molenwijk-popup-open');
            try {
                sessionStorage.setItem('molenwijk-popup-dismissed', '1');
            } catch (error) {
                // Storage is optional.
            }
        });

        popup.showModal();
        popup.focus({ preventScroll: true });
        document.body.classList.add('molenwijk-popup-open');
    }
}
